// 鍏变韩甯搁噺涓庡伐鍏凤細浠?src/views/smart-workbench/index.vue 鐨勬ā鍧楃骇甯搁噺鍖烘媶鍑恒€?
// index.vue 涓庡悇 mixin 浠庤繖閲屽紩鐢紝閬垮厤閲嶅瀹氫箟銆?
import CeoWorkbench from '@/views/workbench-new/ceo/index.vue'
import CfoWorkbench from '@/views/workbench-new/cfo/index.vue'
import CsoWorkbench from '@/views/workbench-new/cso/index.vue'
import DirectorWorkbench from '@/views/workbench-new/director/index.vue'
import WorkbenchRender from '@/views/workbench-new/ceo/index.vue'
import { getWorkspaceId } from '@/api/agentAuth'
import Cookies from 'js-cookie'

// ===== 路由 ↔ agent 双向绑定（唯一数据源） =====
// 路由名 → agentName 权威映射：
//  - constantRoutes.js 中对应子路由 meta.agentName（路由 → agent）
//  - navigation.js _getAgentRouteName()（agent → 路由）
// 新增数字人/智能体路由时，需同步维护本表与 constantRoutes.js 中对应 meta.agentName。
export const AGENT_ROUTE_BINDINGS = [
  { routeName: 'ceoWorkbench', path: 'workbench/ceo', agentName: 'ceo_shu_zi_ren', agentType: 'digital' },
  { routeName: 'cfoWorkbench', path: 'workbench/cfo', agentName: 'cai_wu_shu_zi_ren', agentType: 'digital' },
  { routeName: 'csoWorkbench', path: 'workbench/cso', agentName: 'gong_ying_lian_shu_zi_ren', agentType: 'digital' },
  // 能源站长数字人（tags 含 NY-DH，internalName 兜底为 dh_ny_dh）：驾驶舱指向独立路由 workbench/energy
  { routeName: 'energyWorkbench', path: 'workbench/energy', agentName: 'dh_ny_dh', agentType: 'digital' },
  { routeName: 'SmartEngineAgentIndicator', path: 'agent/indicator', agentName: 'zhi_biao_ding_yi_zhi_neng_ti', agentType: 'agent' },
  { routeName: 'SmartEngineAgentGovernance', path: 'agent/governance', agentName: 'ben_ti_zhi_li_zhi_neng_ti', agentType: 'agent' },
  { routeName: 'SmartEngineAgentDecision', path: 'agent/decision', agentName: 'jing_ying_jue_ce_zhi_neng_ti', agentType: 'agent' }
]

// agentName → 路由名（反向查找，用于菜单点击/深链跳转）
export function getAgentRouteName(agentName) {
  const item = AGENT_ROUTE_BINDINGS.find((b) => b.agentName === agentName)
  return item ? item.routeName : ''
}

export const WORKBENCH_COMPONENTS = {
  ceo: CeoWorkbench,
  cfo: CfoWorkbench,
  cso: CsoWorkbench,
  director: DirectorWorkbench,
  default: WorkbenchRender
}
export const WS_BASE_PATH = '/agent-api/intelligent-agent/api/v1/claw/ws'
export const WS_CLAW_ID = process.env.VUE_APP_WS_CLAW_ID || '2069625662527311874'
export const WS_TOKEN_KEY = process.env.VUE_APP_WS_TOKEN_KEY || 'tianzhi_test_agent_token'
export function getSharedWsUrl(workspaceId) {
  // tianzhi agent token 鐢?fetchAgentToken() 鍦ㄧ櫥褰曞悗鑷姩鑾峰彇骞跺瓨鍏?storage
  const token = Cookies.get(WS_TOKEN_KEY) || ''
  if (!token) return ''
  // 鍔ㄦ€?workspace ID锛氫紭鍏堜娇鐢ㄤ紶鍏ョ殑鐪熷疄 workspaceId锛屽叾娆＄敤鐜鍙橀噺鍏滃簳
  let wsId = workspaceId
  if (!wsId) {
    try {
      wsId = getWorkspaceId()
    } catch (e) {
      console.log(e)
    }
  }
  if (!wsId) return ''
  return `${WS_BASE_PATH}?claw_id=${WS_CLAW_ID}&workspace_id=${wsId}&t=${encodeURIComponent(
    token
  )}`
}
